import { render, staticRenderFns } from "./importMainBigModel.vue?vue&type=template&id=1617e916&scoped=true&"
import script from "./importMainBigModel.vue?vue&type=script&lang=js&"
export * from "./importMainBigModel.vue?vue&type=script&lang=js&"
import style0 from "./importMainBigModel.vue?vue&type=style&index=0&id=1617e916&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1617e916",
  null
  
)

export default component.exports